
<div>
    <p>Dear [client],</p>
    <p>Our next billing cycle will include the fees for February, March, and April to bring your account up to date. After this alignment, you will see your advisory fees billed on a standard monthly basis.</p>
    <p>No action is required on your part, but please feel free to reach out if you have any questions.</p>
    <p>Best Regards.</p>
</div>
